import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { readStyle } from "./indicatorUtils";

export const createMFI = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const mfiS = readStyle(styles, "mfi", "#2196F3");

  return {
    name: "mfi",
    shortName: `MFI${period}`,
    calcParams: [period],
    series: "normal" as const,
    minValue: 0,
    maxValue: 100,
    figures: [{ key: "mfi", title: `MFI${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(mfiS.color, 2, lineStyleToKLine(mfiS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "mfi", title: `MFI${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p] = (indicator.calcParams ?? [period]) as [number];
      const n = dataList.length;
      const results: Array<{ mfi?: number }> = new Array(n);
      results[0] = {};

      const posBuf: number[] = new Array(p);
      const negBuf: number[] = new Array(p);
      let bufIdx = 0;
      let bufCount = 0;
      let posSum = 0;
      let negSum = 0;

      for (let i = 1; i < n; i++) {
        const tp =
          (dataList[i]!.high + dataList[i]!.low + dataList[i]!.close) / 3;
        const prevTp =
          (dataList[i - 1]!.high +
            dataList[i - 1]!.low +
            dataList[i - 1]!.close) /
          3;
        const vol = dataList[i]!.volume ?? 0;
        const flow = tp * vol;
        const pos = tp > prevTp ? flow : 0;
        const neg = tp < prevTp ? flow : 0;

        const evP = bufCount === p ? posBuf[bufIdx]! : 0;
        const evN = bufCount === p ? negBuf[bufIdx]! : 0;
        posBuf[bufIdx] = pos;
        negBuf[bufIdx] = neg;
        bufIdx = (bufIdx + 1) % p;
        if (bufCount < p) bufCount++;
        posSum += pos - evP;
        negSum += neg - evN;

        if (i < p) {
          results[i] = {};
        } else if (negSum === 0) {
          results[i] = { mfi: posSum > 0 ? 100 : 50 };
        } else {
          const ratio = posSum / negSum;
          results[i] = { mfi: 100 - 100 / (1 + ratio) };
        }
      }

      return results;
    },
  };
};
